module.exports = __webpack_public_path__ + "static/media/link-solid-white.c97c438e.svg";